import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const GoogleSlidesLessonDuplicateConfirm = props => (
	<Confirm
		btOne={localize('global_cancel')}
		btTwo={localize('googleSlides_duplicateConfirm_mainButtonNew')}
		alertTitle={localize('googleSlides_duplicateConfirm_title')}
		alertMessage={localize('googleSlides_duplicateConfirm_message')}
		actionButtonType={0}
		actionOne={props.actions.duplicateReject}
		actionTwo={() => props.actions.duplicateConfirm(props.lessonData)}
		closeAction={props.actions.duplicateReject}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		duplicateReject: myLibraryActions.duplicateLessonConfirmDismiss,
		duplicateConfirm: myLibraryActions.duplicateLessonConfirmed,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GoogleSlidesLessonDuplicateConfirm)

export { GoogleSlidesLessonDuplicateConfirm }
